import { RootState } from '../../app/store';

import type Filter from './Filter';

export const selectFilters = (state: RootState): Filter => state.filter;

export const selectCategoryMappingIsReady = (state: RootState): boolean =>
  state.categoryMapping.isReady;

export const selectPendingCategorySlugs = (state: RootState): string[] | null =>
  state.categoryMapping.pendingCategorySlugs;

export const selectIdToSlugMap = (state: RootState): Record<number, string> =>
  state.categoryMapping.idToSlug;

export const selectSlugToIdMap = (state: RootState): Record<string, number> =>
  state.categoryMapping.slugToId;

export const idsToSlugs = (
  idToSlug: Record<number, string>,
  ids: number[]
): string[] =>
  ids
    .map((id) => idToSlug[id])
    .filter((slug): slug is string => slug !== undefined);

export const slugsToIds = (
  slugToId: Record<string, number>,
  slugs: string[]
): number[] =>
  slugs
    .map((slug) => slugToId[slug])
    .filter((id): id is number => id !== undefined);
